// angular import
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
// project import
import { AdminComponent } from './theme/layout/admin/admin.component';
import { GuestComponent } from './theme/layout/guest/guest.component';

const routes: Routes = [

  //{ path: '', component: AdminComponent },
  //{
  //  path: '', redirectTo: '/login',
  //  pathMatch: 'full'
  //},
  {
    path: '',
   // redirectTo: 'companylist',
    redirectTo: 'business', //companylist to businesslist url name changes Made as per Piyali suggestion 
    pathMatch: 'full',
    
  },
  {
    path: '',
    component: AdminComponent,
    //canActivate: [AuthGuard],
    children: [
      //{
      //  path: '',
      //  redirectTo: '/login',
      //  pathMatch: 'full'
      //},
      { path: 'business', loadChildren: () => import('./modules/company/company.module').then(m => m.CompanyModule), canActivate: [AuthGuard] },
      { path: '', loadChildren: () => import('../app/modules/accounts/accounts.module').then(m => m.AccountsModule), canActivate: [AuthGuard]  },
      { path: '', loadChildren: () => import('../app/modules/fbidetails/fbidetails.module').then(m => m.FbidetailsModule), canActivate: [AuthGuard]  },
      { path: '', loadChildren: () => import('../app/modules/partners-details/partners-details.module').then(m => m.PartnersDetailsModule), canActivate: [AuthGuard]  },
      { path: '', loadChildren: () => import('../app/modules/tools/tools.module').then(m => m.ToolsModule), canActivate: [AuthGuard] },
      { path: '', loadChildren: () => import('../app/modules/computations/computations.module').then(m => m.ComputationsModule), canActivate: [AuthGuard] },

      //{ path: 'accountingperiod', loadChildren: () => import('./modules/accounts/accounts.module').then(m => m.AccountsModule) },
      {
        path: 'dashboard',
        loadChildren: () => import('./demo/dashboard/dashboard.module').then((m) => m.DashboardModule)
      },
      {
        path: 'layout',
        loadChildren: () => import('./demo/layout/layout.module').then((m) => m.LayoutModule)
      },
      //{
      //  path: 'widget',
      //  loadChildren: () => import('./demo/widget/widget.module').then((m) => m.WidgetModule)
      //},
      //{
      //  path: 'basic',
      //  loadChildren: () => import('./demo/ui-elements/ui-basic/ui-basic.module').then((m) => m.UiBasicModule)
      //},
      //{
      //  path: 'advance',
      //  loadChildren: () => import('./demo/ui-elements/ui-adv/ui-adv.module').then((m) => m.UiAdvModule)
      //},
      //{
      //  path: 'animation',
      //  loadChildren: () => import('./demo/pages/animation/animation.module').then((m) => m.AnimationModule)
      //},
      {
        path: 'forms',
        loadChildren: () => import('./demo/pages/form-elements/form-elements.module').then((m) => m.FormElementsModule), canActivate: [AuthGuard]
      },
      {
        path: 'plugin',
        loadChildren: () => import('./demo/pages/form-plugin/form-plugin.module').then((m) => m.FormPluginModule), canActivate: [AuthGuard]
      },
      {
        path: 'layout',
        loadChildren: () => import('./demo/pages/form-layout/form-layout.module').then((m) => m.FormLayoutModule), canActivate: [AuthGuard]
      },
      {
        path: 'imagesCropper',
        loadComponent: () => import('./demo/pages/image-cropper/image-cropper.component'), canActivate: [AuthGuard]
      },
      {
        path: 'tables',
        loadChildren: () => import('./demo/pages/tables/tables.module').then((m) => m.TablesModule), canActivate: [AuthGuard]
      },
      // {
      //   path: 'chart',
      //   loadChildren: () => import('./demo/pages/core-chart/core-chart.module').then((m) => m.CoreChartModule)
      // },
      {
        path: 'map',
        loadChildren: () => import('./demo/pages/core-map/core-map.module').then((m) => m.CoreMapModule), canActivate: [AuthGuard]
      },
      {
        path: 'message',
        loadComponent: () => import('./demo/application/inline-chat/inline-chat.component'), canActivate: [AuthGuard]
      },
      {
        path: 'task',
        loadChildren: () => import('./demo/application/task/task.module').then((m) => m.TaskModule), canActivate: [AuthGuard]
      },
      {
        path: 'todo',
        loadChildren: () => import('./demo/application/todo/todo.module').then((m) => m.TodoModule)
      },
      {
        path: 'gallery',
        loadChildren: () => import('./demo/application/gallery/gallery.module').then((m) => m.GalleryModule)
      },
      {
        path: 'editor',
        loadChildren: () => import('./demo/extension/editor/editor.module').then((m) => m.EditorModule)
      },
      {
        path: 'file-upload',
        loadComponent: () => import('./demo/extension/files-upload/files-upload.component')
      },
      {
        path: 'full-calendar',
        loadChildren: () =>
          import('./demo/extension/full-event-calendar/full-event-calendar.module').then((module) => module.FullEventCalendarModule)
      },
      {
        path: 'invoice',
        loadChildren: () => import('./demo/extension/invoice/invoice.module').then((m) => m.InvoiceModule)
      },
      {
        path: 'sample-page',
        loadComponent: () => import('./demo/extra/sample-page/sample-page.component')
      }


    ]
  },

  {
    path: '',
    component: GuestComponent,
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./demo/pages/authentication/authentication.module').then((m) => m.AuthenticationModule)
      },
      {
        path: 'maintenance',
        loadChildren: () => import('./demo/pages/maintenance/maintenance.module').then((m) => m.MaintenanceModule)
      },
      {
        path: 'landing',
        loadChildren: () => import('./demo/pages/landing/landing.module').then((m) => m.LandingModule)
      }
    ]
  },


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
